<template lang="pug">
div
  v-card(flat)
    v-card-title Public Safety and Security
    v-container
      keep-alive
        validation-observer(ref="o05" v-slot="{ invalid }" :persist="true" vid="o05")
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Will the event experience a large number of people, require vigorous activity or be held outside during extreme hot or cold weather?
              v-radio-group(v-model="SEA_PSS_Extreme" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Does the event require any street closures?
              v-radio-group(v-model="SEA_PSS_StreetClosures" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Will any vehicles such as cars, vendor trucks or supply trucks be allowed within the closure area?
                v-radio-group(v-model="SEA_PSS_ClosureArea" row dense :disabled="disabled")
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option"
                    :label="option"
                    :value="option"
                  )
          div.d-flex.align-center(v-if="SEA_PSS_ClosureArea === 'Yes'" :style={paddingLeft: '40px'})
            p.pb-0.body-1 Describe the type of vehicles and approximate number of vehicles permitted in closure area.
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12" v-if="SEA_PSS_ClosureArea === 'Yes'" :style={paddingLeft: '40px'})
              validation-provider( rules="required" v-slot="{ errors }" immediate)
                v-textarea.pb-3.pl-3(outlined hide-details dense v-model="SEA_PSS_ClosureAreaDesc" :disabled="disabled" )
                p.pb-0.red--text.text--lighten-1.pl-4 {{errors[0]}}
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Does the event plan include any security checkpoints for screening attendees?
              v-radio-group(v-model="SEA_PSS_Checkpoints" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Will there be any hazardous materials or chemicals in use during the event? Examples include gasoline, propane, chlorine/bleach, or acids.
              v-radio-group(v-model="SEA_PSS_Hazardous" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
          div.d-flex.align-center(v-if="SEA_PSS_Hazardous === 'Yes'" :style={paddingLeft: '40px'})
            p.pb-0.body-1 Please describe the type of materials or chemicals and the purpose.
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12" v-if="SEA_PSS_Hazardous === 'Yes'" :style={paddingLeft: '40px'})
              validation-provider( rules="required" v-slot="{ errors }" immediate)
                v-textarea.pb-3.pl-3(outlined hide-details dense v-model="SEA_PSS_HazardousPurpose" :disabled="disabled" )
                p.pb-0.red--text.text--lighten-1.pl-4 {{errors[0]}}
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Are there any circumstances, known threats or reasons you believe there is a need for additional security staff?
              v-radio-group(v-model="SEA_PSS_KnownThreats" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
          div.d-flex.align-center(v-if="SEA_PSS_KnownThreats === 'Yes'" :style={paddingLeft: '40px'})
            p.pb-0.body-1 Please describe why you believe there is a need for additional security staff.
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12" v-if="SEA_PSS_KnownThreats === 'Yes'" :style={paddingLeft: '40px'})
              validation-provider( rules="required" v-slot="{ errors }" immediate)
                v-textarea.pb-3.pl-3(outlined hide-details dense v-model="SEA_PSS_SecurityStaff" :disabled="disabled" )
                p.pb-0.red--text.text--lighten-1.pl-4 {{errors[0]}}
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Will the event include amplified sound (including music and disc jockeys)?
              v-radio-group(v-model="SEA_PSS_Sound" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
          div.d-flex.align-center(v-if="SEA_PSS_Sound === 'Yes'" :style={paddingLeft: '40px'})
            p.pb-0.body-1 Describe the amplified sound and equipment.
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12" v-if="SEA_PSS_Sound === 'Yes'" :style={paddingLeft: '40px'})
              validation-provider( rules="required" v-slot="{ errors }" immediate)
                v-textarea.pb-3.pl-3(outlined hide-details dense v-model="SEA_PSS_SoundDesc" :disabled="disabled" )
                p.pb-0.red--text.text--lighten-1.pl-4 {{errors[0]}}
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Will the event have equipment left overnight or require security?
              v-radio-group(v-model="SEA_PSS_Overnight" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Is the event an indoor or outdoor assemblage, carnival, fair or festival?
              validation-provider( rules="required" v-slot="{ errors }" immediate)
                v-radio-group(v-model="SEA_PSS_Assemblage" row dense :disabled="disabled")
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option"
                    :label="option"
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{errors[0]}}
          div.d-flex.align-center(v-if="SEA_PSS_Assemblage === 'Yes'" :style={paddingLeft: '40px'})
            p.pb-0.body-1 A Fire Prevention Special Events Permit is required for indoor or outdoor assemblages, carnivals, fairs and festivals. Contact the Arlington County Fire Prevention Division at 703-228-4644.
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Will there be animals (such as dogs, a petting zoo, hayrides or pony rides) in the event?
              v-radio-group(v-model="SEA_Animals" row dense :disabled="disabled")
                v-radio(
                  v-for="option in yesNoString",
                  :key="option"
                  :label="option"
                  :value="option"
                )
          v-row(v-if="SEA_Animals === 'Yes'")
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              v-card-title.pb-4 Animal Welfare
              p.pb-0.pl-8.text--secondary If there are animals (such as dogs, a petting zoo, hayrides or pony rides) in the event, the animals will need to be certified to have all the proper immunizations, such as the Coggins Test, and be able to show proof of the Health Certificate. Contact the Department of Animal Control at the Arlington Animal Welfare League (703-931-9241 or <a href="mailto:mail@awla.org">mail@awla.org</a>).
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              v-card-title.pb-4 Special Event Insurance
              p.pb-0.pl-8.text--secondary The County requires most events to provide evidence of a commercial general liability insurance policy with limits of not less than $1,000,000 per occurrence and $2,000,000 annual aggregate. The policy must be endorsed to include: "The Arlington County (including its elected and appointed officials, agents and employees) as an additional insured with respect to (Name of Event)" and "Coverage afforded under this policy shall be primary to all other insurance with respect to Arlington County (including its elected and appointed officials, agents and employees)." <strong>Certificate must be submitted no later than one week prior to the event</strong>.
              p.pb-0.pl-8.text--secondary The County can direct events to lower cost insurance policies. Events sponsored by Civic Associations and small neighborhood events where the attendance is anticipated to be 150 people or less, that require street closure of not more than two blocks of a non-primary, residential street, and do not include vendors do not require insurance.
              p.pb-0.pl-8.text--secondary Events must consciously plan safety and risk control measures. For more information about what insurance is required or help obtaining special event insurance contact the Office of Risk Management at 702-228-4444.          
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Do you have Special Event Insurance?
              validation-provider( rules="required" v-slot="{ errors }" immediate)
                v-radio-group(v-model="SEA_Insurance" row dense :disabled="disabled")
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option"
                    :label="option"
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{errors[0]}}
          div.d-flex.align-center(v-if="SEA_Insurance === 'Yes'" :style={paddingLeft: '40px'})
            p.pb-0.body-1 Insurance Provider Name
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12" v-if="SEA_Insurance === 'Yes'" :style={paddingLeft: '40px'})
              validation-provider( rules="required" v-slot="{ errors }" immediate)
                v-text-field.pb-3.pl-3(outlined, hide-details, dense, v-model="SEA_InsuranceName" :disabled="disabled")
                p.pb-0.red--text.text--lighten-1.pl-4 {{errors[0]}}
          v-row
            v-col(:lg="12" :md="12" :sm="12" :cols="12")
              p.pb-0.body-1 Do you have a Special Event Business License?
              p.pb-0.pl-8.text--secondary For-profit groups must obtain a Special Events Business License from the Commissioner of the Revenue.
              p.pb-0.pl-8.text--secondary For more information call the Commissioner of Revenue, Business License Section at 703-228-3060.
              validation-provider(rules="required", v-slot="{ errors }" immediate)
                v-radio-group(v-model="SEA_License" row dense :disabled="disabled")
                  v-radio(
                    v-for="option in yesNoString",
                    :key="option"
                    :label="option"
                    :value="option"
                  )
                p.pb-0.red--text.text--lighten-1.pl-4 {{errors[0]}}
                
</template>


<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import store from "../store";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  components: {
    //
    ValidationProvider,
    ValidationObserver,
  },
  store,
  computed: {
    ...mapState({
      data: (state) => state.data,
      yesNoString: (state) => state.yesNoString,
    }),
    ...mapFields([
      "data.SEA_PSS_Extreme",
      "data.SEA_PSS_StreetClosures",
      "data.SEA_PSS_ClosureArea",
      "data.SEA_PSS_ClosureAreaDesc",
      "data.SEA_PSS_Checkpoints",
      "data.SEA_PSS_Hazardous",
      "data.SEA_PSS_HazardousPurpose",
      "data.SEA_PSS_KnownThreats",
      "data.SEA_PSS_SecurityStaff",
      "data.SEA_PSS_Sound",
      "data.SEA_PSS_SoundDesc",
      "data.SEA_PSS_Overnight",
      "data.SEA_PSS_Assemblage",
      "data.SEA_Animals",
      "data.SEA_Insurance",
      "data.SEA_InsuranceName",
      "data.SEA_License",
      "data.disabled",
    ]),
  },
  data: () => ({
    //
  }),
  methods: {
    //
  },
};
</script>